import React, { useState, useRef, useEffect } from 'react';
import { MapPin, ChevronLeft, ChevronRight, Users, ArrowRight, X, ZoomIn, TrendingUp, Sparkles, Target } from 'lucide-react';

// Small wins - для новичков
const smallWins = [
  { text: 'Первые €300 за неделю', name: 'Марина', icon: '💰' },
  { text: 'Первые 2 продажи', name: 'Антон', icon: '📦' },
  { text: 'Первый положительный ROI', name: 'Игорь', icon: '📈' },
];

// Импорт изображений
import dmitriyResult from '../../assets/dmitriy-result.png';
import denisResult from '../../assets/denis-result.png';
import valeriaResult from '../../assets/valeria-result.png';
import evgeniyResult from '../../assets/evgeniy-result.png';
import elenaResult from '../../assets/elena-result.png';
import vadimResult from '../../assets/vadim-result.png';
import alexanderResult from '../../assets/alexander-result.png';
import andreyResult from '../../assets/andrey-result.png';
import kirilResult from '../../assets/kiril-result.png';
import anonymousResult from '../../assets/anonymous-result.png';
import marinaResult from '../../assets/marina-result.png';
import anatoliyResult from '../../assets/anatoliy-result.png';
import nikitaResult from '../../assets/nikita-result.png';
import dariaResult from '../../assets/daria-result.png';
import igorResult from '../../assets/igor-result.png';
import alexeyResult from '../../assets/alexey-result.png';
import igor2Result from '../../assets/igor2-result.png';
import andrey2Result from '../../assets/andrey2-result.png';

// Country flags
const countryFlags = {
  'Германия': '🇩🇪',
  'США': '🇺🇸',
  'Польша': '🇵🇱',
  'Италия': '🇮🇹',
  'Испания': '🇪🇸',
  'Чехия': '🇨🇿',
  'Европа': '🇪🇺',
  'Австрия': '🇦🇹',
  'Нидерланды': '🇳🇱',
  'Франция': '🇫🇷',
  'Ирландия': '🇮🇪',
};

const students = [
  {
    id: 0,
    name: 'Измаил',
    location: 'Германия',
    market: 'Amazon Германия',
    result: '€472,956',
    resultLabel: 'продажи',
    image: 'https://customer-assets.emergentagent.com/job_amazon-course-1/artifacts/kykxsbrv_image.png',
    color: 'amber',
  },
  {
    id: 1,
    name: 'Алексей',
    location: 'США',
    market: 'Amazon США',
    result: '$65,887',
    resultLabel: 'за месяц',
    image: alexeyResult,
    color: 'emerald',
  },
  {
    id: 2,
    name: 'Вадим',
    location: 'США',
    market: 'Amazon США',
    result: '$19,267',
    resultLabel: 'за месяц',
    image: vadimResult,
    color: 'violet',
  },
  {
    id: 3,
    name: 'Дмитрий',
    location: 'Италия',
    market: 'Amazon Италия',
    result: '€39,818',
    resultLabel: 'за месяц',
    image: dmitriyResult,
    color: 'amber',
  },
  {
    id: 4,
    name: 'Валерия',
    location: 'Польша',
    market: 'Amazon Германия',
    result: '€32,348',
    resultLabel: 'за месяц',
    image: valeriaResult,
    color: 'blue',
  },
  {
    id: 5,
    name: 'Анатолий',
    location: 'Европа',
    market: 'Amazon ЕС',
    result: '€17,952',
    resultLabel: 'продажи',
    image: anatoliyResult,
    color: 'rose',
  },
  {
    id: 6,
    name: 'Елена',
    location: 'Италия',
    market: 'Amazon Италия',
    result: '€10,720',
    resultLabel: 'за месяц',
    image: elenaResult,
    color: 'rose',
  },
  {
    id: 7,
    name: 'Кирил',
    location: 'Польша',
    market: 'Amazon США',
    result: '$3,245',
    resultLabel: 'за день',
    image: kirilResult,
    color: 'cyan',
  },
  {
    id: 8,
    name: 'Евгений',
    location: 'Италия',
    market: 'Amazon Италия',
    result: '€9,256',
    resultLabel: 'за месяц',
    image: evgeniyResult,
    color: 'orange',
  },
  {
    id: 9,
    name: 'Андрей',
    location: 'Португалия',
    market: 'Amazon США',
    result: '$2,170',
    resultLabel: 'продажи',
    image: andreyResult,
    color: 'teal',
  },
  {
    id: 10,
    name: 'Марина',
    location: 'Канада',
    market: 'Amazon Канада',
    result: '1870 CAD',
    resultLabel: 'за месяц',
    image: marinaResult,
    color: 'indigo',
  },
  {
    id: 11,
    name: 'Александр',
    location: 'Испания',
    market: 'Amazon США',
    result: '316 units',
    resultLabel: 'продано',
    image: alexanderResult,
    color: 'pink',
  },
  {
    id: 12,
    name: 'Ученик',
    location: 'Германия',
    market: 'Amazon США',
    result: '$1,279',
    resultLabel: 'за месяц',
    image: anonymousResult,
    color: 'emerald',
  },
  {
    id: 13,
    name: 'Дария',
    location: 'Италия',
    market: 'Amazon Италия',
    result: '€485',
    resultLabel: 'сегодня',
    image: dariaResult,
    color: 'violet',
  },
  {
    id: 14,
    name: 'Денис',
    location: 'Польша',
    market: 'Amazon США',
    result: '$236',
    resultLabel: 'первая неделя',
    image: denisResult,
    color: 'amber',
  },
  {
    id: 15,
    name: 'Никита',
    location: 'Германия',
    market: 'Amazon Германия',
    result: '€114',
    resultLabel: 'за неделю',
    image: nikitaResult,
    color: 'blue',
  },
  {
    id: 16,
    name: 'Игорь',
    location: 'Италия',
    market: 'Amazon Италия',
    result: '€1,500+',
    resultLabel: 'за месяц',
    image: igorResult,
    color: 'rose',
  },
  {
    id: 17,
    name: 'Игорь2',
    location: 'США',
    market: 'Amazon США',
    result: '$4,503',
    resultLabel: 'за месяц',
    image: igor2Result,
    color: 'cyan',
  },
  {
    id: 18,
    name: 'Андрей2',
    location: 'Ирландия',
    market: 'Amazon США',
    result: '$9,516',
    resultLabel: 'продажи',
    image: andrey2Result,
    color: 'orange',
  },
];

const colorStyles = {
  emerald: { bg: 'from-emerald-500/20 to-teal-500/20', border: 'border-emerald-500/40', text: 'text-emerald-400' },
  violet: { bg: 'from-violet-500/20 to-purple-500/20', border: 'border-violet-500/40', text: 'text-violet-400' },
  amber: { bg: 'from-amber-500/20 to-orange-500/20', border: 'border-amber-500/40', text: 'text-amber-400' },
  blue: { bg: 'from-blue-500/20 to-indigo-500/20', border: 'border-blue-500/40', text: 'text-blue-400' },
  rose: { bg: 'from-rose-500/20 to-pink-500/20', border: 'border-rose-500/40', text: 'text-rose-400' },
  cyan: { bg: 'from-cyan-500/20 to-sky-500/20', border: 'border-cyan-500/40', text: 'text-cyan-400' },
  orange: { bg: 'from-orange-500/20 to-red-500/20', border: 'border-orange-500/40', text: 'text-orange-400' },
  teal: { bg: 'from-teal-500/20 to-green-500/20', border: 'border-teal-500/40', text: 'text-teal-400' },
  indigo: { bg: 'from-indigo-500/20 to-blue-500/20', border: 'border-indigo-500/40', text: 'text-indigo-400' },
  pink: { bg: 'from-pink-500/20 to-rose-500/20', border: 'border-pink-500/40', text: 'text-pink-400' },
};

const ImageModal = ({ student, students, onClose, onNavigate }) => {
  // Touch swipe support for mobile - hooks must be called before any early returns
  const [touchStart, setTouchStart] = React.useState(null);
  const [touchEnd, setTouchEnd] = React.useState(null);
  const minSwipeDistance = 50;
  
  const currentIndex = student ? students.findIndex(s => s.id === student.id && s.name === student.name) : -1;
  const hasPrev = currentIndex > 0;
  const hasNext = currentIndex < students.length - 1;
  
  const goToPrev = React.useCallback((e) => {
    if (e) e.stopPropagation();
    if (hasPrev && student) onNavigate(students[currentIndex - 1]);
  }, [hasPrev, student, currentIndex, students, onNavigate]);
  
  const goToNext = React.useCallback((e) => {
    if (e) e.stopPropagation();
    if (hasNext && student) onNavigate(students[currentIndex + 1]);
  }, [hasNext, student, currentIndex, students, onNavigate]);
  
  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };
  
  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  
  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    
    if (isLeftSwipe && hasNext) {
      goToNext();
    } else if (isRightSwipe && hasPrev) {
      goToPrev();
    }
  };
  
  // Prevent body scroll when modal is open
  React.useEffect(() => {
    if (student) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [student]);
  
  // Keyboard navigation
  React.useEffect(() => {
    if (!student) return;
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft') goToPrev();
      if (e.key === 'ArrowRight') goToNext();
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [student, goToPrev, goToNext, onClose]);
  
  if (!student) return null;
  
  return (
    <div 
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/95" 
      onClick={onClose}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      data-testid="image-modal-overlay"
    >
      {/* Close button */}
      <button 
        onClick={(e) => { e.stopPropagation(); onClose(); }} 
        className="absolute top-4 right-4 w-12 h-12 rounded-full bg-zinc-800 border border-zinc-700 flex items-center justify-center text-white hover:bg-zinc-700 active:bg-zinc-600 transition-colors z-[110]"
        data-testid="modal-close-button"
      >
        <X className="w-6 h-6" />
      </button>
      
      {/* Counter */}
      <div className="absolute top-4 left-1/2 -translate-x-1/2 px-4 py-2 rounded-full bg-zinc-800/80 text-white text-sm font-medium z-[110]">
        {currentIndex + 1} / {students.length}
      </div>
      
      {/* Navigation arrows */}
      {hasPrev && (
        <button 
          onClick={goToPrev}
          className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-zinc-800/90 border border-zinc-700 flex items-center justify-center text-white hover:bg-zinc-700 active:bg-zinc-600 transition-colors z-[110]"
          data-testid="modal-prev-button"
        >
          <ChevronLeft className="w-6 h-6 sm:w-7 sm:h-7" />
        </button>
      )}
      {hasNext && (
        <button 
          onClick={goToNext}
          className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-zinc-800/90 border border-zinc-700 flex items-center justify-center text-white hover:bg-zinc-700 active:bg-zinc-600 transition-colors z-[110]"
          data-testid="modal-next-button"
        >
          <ChevronRight className="w-6 h-6 sm:w-7 sm:h-7" />
        </button>
      )}
      
      {/* Image - improved mobile view */}
      <div 
        className="relative w-full max-w-5xl mx-2 sm:mx-4 flex items-center justify-center" 
        onClick={(e) => e.stopPropagation()}
      >
        <img 
          src={student.image} 
          alt={`Результаты ${student.name}`} 
          className="max-w-full max-h-[75vh] sm:max-h-[80vh] w-auto h-auto object-contain rounded-xl sm:rounded-2xl select-none"
          draggable={false}
        />
        {/* Info badge */}
        <div className="absolute bottom-2 sm:bottom-4 left-2 sm:left-4 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full bg-black/70 backdrop-blur-sm text-white font-medium text-sm sm:text-base">
          {student.name} • {student.result}
        </div>
      </div>
      
      {/* Hint - different for mobile/desktop */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-3 text-zinc-400 text-sm z-[110]">
        <span className="hidden sm:inline">← →</span>
        <span className="sm:hidden">свайп</span>
        <span>листать</span>
      </div>
    </div>
  );
};

const StudentCard = ({ student, isActive, onImageClick }) => {
  const colors = colorStyles[student.color];
  const flag = countryFlags[student.location] || '🌍';
  
  // Handle click for image - unified handler
  const handleImageClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onImageClick(student);
  };
  
  return (
    <div className={`relative transition-all duration-500 ${isActive ? 'scale-100 opacity-100' : 'scale-95 opacity-50'}`}>
      <div className={`absolute -inset-2 bg-gradient-to-br ${colors.bg} rounded-3xl blur-xl opacity-60`} />
      <div className={`relative bg-gradient-to-b from-zinc-800/90 to-zinc-900/90 backdrop-blur-xl rounded-3xl overflow-hidden border ${colors.border} hover-lift`}>
        <div className="p-4 sm:p-5">
          <div className="mb-3">
            <h3 className="text-lg sm:text-xl font-black text-white mb-1">{student.name}</h3>
            <div className="flex items-center gap-1.5 text-zinc-400">
              <span className="text-base">{flag}</span>
              <span className="text-xs">{student.location}</span>
              <span className="text-zinc-600">•</span>
              <span className="text-xs">{student.market}</span>
            </div>
          </div>
          <div>
            <div className={`text-2xl sm:text-3xl font-black ${colors.text}`}>{student.result}</div>
            <p className="text-zinc-500 text-xs">{student.resultLabel}</p>
          </div>
        </div>
        {/* Image container - using button for better touch handling */}
        <button 
          type="button"
          onClick={handleImageClick}
          onTouchEnd={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onImageClick(student);
          }}
          className="relative w-full cursor-pointer group block"
          data-testid={`student-image-${student.id}`}
          style={{ WebkitTapHighlightColor: 'transparent', touchAction: 'manipulation' }}
        >
          {/* Persistent "tap to zoom" pill — visible on mobile by default so users
              know the card is interactive without having to hover. */}
          <div className="absolute top-2 right-2 z-20 flex items-center gap-1 px-2 py-1 rounded-full bg-black/70 backdrop-blur-sm border border-white/20 text-white text-[10px] font-bold pointer-events-none">
            <ZoomIn className="w-3 h-3" />
            <span className="hidden sm:inline">Нажмите</span>
          </div>
          {/* Hover/active dark overlay */}
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 active:bg-black/40 transition-all duration-300 z-10 flex items-center justify-center pointer-events-none">
            <div className="opacity-0 group-hover:opacity-100 group-active:opacity-100 transition-opacity duration-300 flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/20 backdrop-blur-sm text-white font-medium text-sm">
              <ZoomIn className="w-4 h-4" />
              <span>Увеличить</span>
            </div>
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-zinc-900 via-transparent to-transparent z-[5] pointer-events-none" />
          <img 
            src={student.image} 
            alt={`Результаты ${student.name}`} 
            className="w-full h-56 sm:h-52 object-cover object-center group-hover:scale-105 transition-transform duration-500 select-none pointer-events-none" 
            draggable={false}
          />
        </button>
      </div>
    </div>
  );
};

const StudentResultsSection = ({
  badge = 'РЕЗУЛЬТАТЫ УЧЕНИКОВ',
  titleA = 'Результаты',
  titleB = ' учеников',
  subtitleLead = 'Они уже ',
  subtitleEmphasis = 'зарабатывают',
  description = (
    <>
      <span className="text-emerald-400 font-bold">Реальные скриншоты</span> из Seller Central наших учеников
    </>
  ),
  ctaLabel = 'Хочу такие же результаты',
  ctaHref = '#pricing',
  ctaOnClick = null,
  showCta = true,
} = {}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [modalImage, setModalImage] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  
  const nextStudent = () => setActiveIndex((prev) => (prev + 1) % students.length);
  const prevStudent = () => setActiveIndex((prev) => (prev - 1 + students.length) % students.length);
  const openModal = (student) => setModalImage(student);
  const closeModal = () => setModalImage(null);

  // Split into rows of 7 for desktop
  const firstRow = students.slice(0, 7);
  const secondRow = students.slice(7, 14);
  const thirdRow = students.slice(14, 19);

  return (
    <>
      {/* Modal rendered outside section to avoid overflow:hidden clipping */}
      <ImageModal student={modalImage} students={students} onClose={closeModal} onNavigate={setModalImage} />
      
      <section ref={sectionRef} className="relative py-20 sm:py-24 lg:py-32 overflow-hidden bg-[#050506]" id="results">
      
      {/* Animated background */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-0 w-[800px] h-[800px] bg-emerald-500/[0.04] rounded-full blur-[200px] animate-pulse" />
        <div className="absolute bottom-0 right-1/4 w-[600px] h-[600px] bg-teal-500/[0.03] rounded-full blur-[150px] animate-pulse" style={{ animationDelay: '1s' }} />
        
        {/* Floating particles */}
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1.5 h-1.5 rounded-full animate-pulse"
            style={{
              background: i % 2 === 0 ? '#10b981' : '#14b8a6',
              left: `${5 + (i * 6)}%`,
              top: `${10 + (i * 5) % 80}%`,
              animationDelay: `${i * 0.2}s`,
              animationDuration: `${2 + i * 0.3}s`
            }}
          />
        ))}
      </div>

      <div className="relative z-10 max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* MEGA Animated Header */}
        <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          
          {/* Badge with glow */}
          <div className="relative inline-block mb-6">
            <div className="absolute -inset-1 bg-gradient-to-r from-emerald-500/50 to-teal-500/50 rounded-full blur-lg animate-pulse" />
            <div className="relative inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-gradient-to-r from-emerald-500/20 to-teal-500/20 border border-emerald-500/40 backdrop-blur-xl">
              <Users className="w-4 h-4 text-emerald-400 animate-bounce" style={{ animationDuration: '2s' }} />
              <span className="text-emerald-300 font-bold text-sm tracking-wide">{badge}</span>
            </div>
          </div>
          
          {/* Title - "Результаты учеников" animated */}
          <h2 className={`text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-black mb-4 sm:mb-6 transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <span className="relative inline-block">
              <span className="bg-gradient-to-r from-white via-emerald-100 to-white bg-clip-text text-transparent">
                {titleA}
              </span>
              {/* Sparkle effects */}
              <Sparkles className={`absolute -top-4 -right-6 w-6 h-6 text-emerald-400 transition-all duration-1000 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-0'}`} style={{ transitionDelay: '800ms' }} />
            </span>
            <span className="text-white">{titleB}</span>
          </h2>
          
          {/* "Они уже зарабатывают" - animated */}
          <div className={`mb-4 transition-all duration-1000 delay-400 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <p className="text-3xl sm:text-4xl lg:text-5xl font-black">
              <span className="text-zinc-400">{subtitleLead}</span>
              <span className="relative inline-block">
                <span className="bg-gradient-to-r from-emerald-400 via-teal-400 to-emerald-400 bg-clip-text text-transparent bg-[length:200%_auto] animate-gradient">
                  {subtitleEmphasis}
                </span>
                {/* Animated underline */}
                <svg className="absolute -bottom-2 left-0 w-full h-3" viewBox="0 0 200 12" fill="none" preserveAspectRatio="none">
                  <path d="M2 10C50 2 150 2 198 10" stroke="url(#results-underline)" strokeWidth="4" strokeLinecap="round" strokeDasharray="200" strokeDashoffset="200" style={{ animation: isVisible ? 'draw 1.5s ease-out forwards 0.6s' : 'none' }}/>
                  <defs>
                    <linearGradient id="results-underline" x1="0" y1="0" x2="200" y2="0">
                      <stop stopColor="#10b981"/>
                      <stop offset="0.5" stopColor="#14b8a6"/>
                      <stop offset="1" stopColor="#10b981"/>
                    </linearGradient>
                  </defs>
                </svg>
              </span>
            </p>
          </div>
          
          {/* "Реальные скриншоты" - animated with glow */}
          <div className={`transition-all duration-1000 delay-600 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <div className="relative inline-block">
              <div className="absolute -inset-2 bg-gradient-to-r from-emerald-500/20 via-teal-500/30 to-emerald-500/20 rounded-xl blur-lg animate-pulse" />
              <p className="relative text-base sm:text-lg lg:text-xl text-zinc-300 px-6 py-3 rounded-xl bg-zinc-800/50 border border-emerald-500/30 backdrop-blur-sm">
                {description}
              </p>
            </div>
          </div>
        </div>

        {/* Mobile Carousel */}
        <div className="lg:hidden">
          {/* Swipe hint */}
          <p className="text-center text-zinc-500 text-sm mb-3 flex items-center justify-center gap-2">
            <ChevronLeft className="w-4 h-4" />
            <span>Листайте для просмотра</span>
            <ChevronRight className="w-4 h-4" />
          </p>
          
          <StudentCard student={students[activeIndex]} isActive={true} onImageClick={openModal} />
          <div className="flex items-center justify-center gap-4 mt-6">
            <button onClick={prevStudent} className="w-12 h-12 rounded-full bg-zinc-800 border border-zinc-700 flex items-center justify-center text-white hover:bg-zinc-700 transition-colors">
              <ChevronLeft className="w-5 h-5" />
            </button>
            <div className="flex items-center gap-1.5">
              {students.map((_, index) => (
                <button key={index} onClick={() => setActiveIndex(index)} className={`w-2 h-2 rounded-full transition-all ${index === activeIndex ? 'w-5 bg-emerald-500' : 'bg-zinc-600 hover:bg-zinc-500'}`} />
              ))}
            </div>
            <button onClick={nextStudent} className="w-12 h-12 rounded-full bg-zinc-800 border border-zinc-700 flex items-center justify-center text-white hover:bg-zinc-700 transition-colors">
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* Desktop Grid - 7 columns */}
        <div className="hidden lg:grid lg:grid-cols-7 gap-4">
          {firstRow.map((student) => (
            <StudentCard key={student.id} student={student} isActive={true} onImageClick={openModal} />
          ))}
        </div>
        <div className="hidden lg:grid lg:grid-cols-7 gap-4 mt-4">
          {secondRow.map((student) => (
            <StudentCard key={student.id} student={student} isActive={true} onImageClick={openModal} />
          ))}
        </div>
        {/* Third row - centered */}
        <div className="hidden lg:flex lg:justify-center gap-4 mt-4">
          {thirdRow.map((student) => (
            <div key={student.id} className="w-[calc(14.28%-12px)]">
              <StudentCard student={student} isActive={true} onImageClick={openModal} />
            </div>
          ))}
        </div>

        {/* CTA */}
        {showCta && (
        <div className={`text-center mt-12 transition-all duration-1000 delay-800 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="relative inline-block group">
            <div className="absolute -inset-2 bg-gradient-to-r from-emerald-500/40 to-teal-500/40 rounded-2xl blur-xl opacity-60 group-hover:opacity-100 transition-opacity" />
            <a 
              href={ctaOnClick ? undefined : ctaHref}
              onClick={ctaOnClick || undefined}
              className="relative inline-flex items-center gap-3 px-10 py-5 bg-gradient-to-r from-emerald-500 to-teal-500 text-black font-black text-lg rounded-2xl shadow-2xl shadow-emerald-500/30 hover:shadow-emerald-500/50 hover:-translate-y-1 active:scale-[0.98] transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" />
              <span className="relative z-10">{ctaLabel}</span>
              <ArrowRight className="w-6 h-6 relative z-10 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </div>
        )}
      </div>
      
      {/* CSS for draw animation */}
      <style>{`
        @keyframes draw {
          to { stroke-dashoffset: 0; }
        }
      `}</style>
    </section>
    </>
  );
};

export default StudentResultsSection;
